// region visibility komt hier, zonder de maintainance mode. Dat is een los compoentn

// region visibiliyt afkijken van edit family component



import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Log } from 'ng2-logger';

const log = Log.create('visibility?');

@Component({
    moduleId: module.id,
    selector: 'region-visibility',
    templateUrl: 'visibility.component.html',
    styleUrls: ['visibility.less']
})
export class VisibilityComponent {
    componentId: string = (Math.random().toString(36) + '00000000000000000').slice(2, 5 + 2);
    disabledValue: boolean = false;
    emeaVisibility: boolean;
    naVisibility: boolean;
    saVisibility: boolean;
    cnVisibility: boolean;
    roaVisibility: boolean;

    @Output() emeaChange: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() naChange: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() saChange: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() cnChange: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() roaChange: EventEmitter<boolean> = new EventEmitter<boolean>();

    @Input() get disabled()   {return this.disabledValue;}

    @Input() get emea()   {return this.emeaVisibility;}
    @Input() get na()     {return this.naVisibility;}
    @Input() get sa()     {return this.saVisibility;}
    @Input() get cn()     {return this.cnVisibility;}
    @Input() get roa()    {return this.roaVisibility;}


    set disabled(val) {
      this.disabledValue = val;
    }

    set emea(val) {
      this.emeaVisibility = val;
      this.emeaChange.emit(this.emeaVisibility);
    }

    set na(val) {
      this.naVisibility = val;
      this.naChange.emit(this.naVisibility);
    }

    set sa(val) {
      this.saVisibility = val;
      this.saChange.emit(this.saVisibility);
    }

    set cn(val) {
      this.cnVisibility = val;
      this.cnChange.emit(this.cnVisibility);
    }

    set roa(val) {
      this.roaVisibility = val;
      this.roaChange.emit(this.roaVisibility);
    }
}



// WEBPACK FOOTER //
// ./src/app/_component/visibility/visibility.component.ts